import React from "react";
import ReportingChart from "../Reporting/ReportingChart";
import _ from "lodash";
import gql from "graphql-tag";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router-dom";

//import { graphql } from "react-apollo";

const ECRITURELINE_CREATED_SUBSCRIPTION = gql`
  subscription onEcritureLineCreated($companyId: ID!) {
    ecritureLineCreated(companyId: $companyId) {
      id
      journal
      amount
      libelle
      libelleExport
      dateOperation
      dateLettrage
      labelLettrage
      tiersClient {
        id
      }
      project {
        id
        tiersClient {
          id
        }
      }
      article {
        id
      }
      category {
        id
      }
    }
  }
`;

const ECRITURELINE_UPDATED_SUBSCRIPTION = gql`
  subscription onEcritureLineUpdated($companyId: ID!) {
    ecritureLineUpdated(companyId: $companyId) {
      id
      journal
      amount
      libelle
      libelleExport
      dateOperation
      dateLettrage
      labelLettrage
      tiersClient {
        id
      }
      project {
        id
        tiersClient {
          id
        }
      }
      article {
        id
      }
      category {
        id
      }
    }
  }
`;

const ECRITURELINE_DELETED_SUBSCRIPTION = gql`
  subscription onEcritureLineDeleted($companyId: ID!) {
    ecritureLineDeleted(companyId: $companyId) {
      id
      journal
      amount
      libelle
      libelleExport
      dateOperation
      dateLettrage
      labelLettrage
      tiersClient {
        id
      }
      project {
        id
        tiersClient {
          id
        }
      }
      article {
        id
      }
      category {
        id
      }
    }
  }
`;

const LETTRAGE_DONE = gql`
  subscription onEcritureLineLettrageDone($companyId: ID!) {
    ecritureLineLettrageDone(companyId: $companyId) {
      date
    }
  }
`;

class EarningsChart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.startCursorArray = [];
  }
  componentDidUpdate() {
    const data =
      this.props.data && this.props.data.ecritureLinesConnectionForEarnings;

    if (!!!data) {
      this.startCursorArray = [];
      return;
    }

    const pageInfo = data && data.pageInfo;

    const startCursor = pageInfo && pageInfo.startCursor;
    if (this.startCursorArray.includes(startCursor)) {
      console.log("146 - already in array:", startCursor);
      return;
    }
    this.startCursorArray.push(startCursor);

    if (pageInfo.hasNextPage) {
      this.props.onLoadMore(
        pageInfo.endCursor,
        "ecritureLinesConnectionForEarnings"
      );
    }
  }

  componentDidMount() {
    // console.log("104 - RentabilityChart.componentDidMount", this);
    this.startCursorArray = [];
    if (!this.props.data) return;

    //this.startCursorArray = [];

    // ecritureLineCreated
    this.unsubscribeEcritureLineCreated = this.props.subscribeToMore({
      document: ECRITURELINE_CREATED_SUBSCRIPTION,
      variables: {
        companyId: this.props.companyId
      },

      updateQuery: (prev, { subscriptionData }) => {
        this.startCursorArray = [];
        this.props.refetch();

        if (!subscriptionData.data) {
          return prev;
        }
        return prev;
      }
    });

    // ecritureLineUpdated
    this.unsubscribeEcritureLineUpdated = this.props.subscribeToMore({
      document: ECRITURELINE_UPDATED_SUBSCRIPTION,
      variables: {
        companyId: this.props.companyId
      },

      updateQuery: (prev, { subscriptionData }) => {
        //this.props.refetch();

        if (!subscriptionData.data) {
          return prev;
        }
        return prev;
      }
    });

    // ecritureLineDeleted
    this.unsubscribeEcritureLineDeleted = this.props.subscribeToMore({
      document: ECRITURELINE_DELETED_SUBSCRIPTION,
      variables: {
        companyId: this.props.companyId
      },

      updateQuery: (prev, { subscriptionData }) => {
        this.startCursorArray = [];
        this.props.refetch();

        if (!subscriptionData.data) {
          return prev;
        }
        return prev;
      }
    });

    // lettageDoneCreated
    this.unsubscribeLettageDone = this.props.subscribeToMore({
      document: LETTRAGE_DONE,
      variables: {
        companyId: this.props.companyId
      },

      updateQuery: (prev, { subscriptionData }) => {
        this.startCursorArray = [];
        this.props.refetch();

        if (!subscriptionData.data) {
          return prev;
        }
        return prev;
      }
    });
    return;
  }

  componentWillUnmount() {
    this.unsubscribeEcritureLineCreated();
    this.unsubscribeEcritureLineUpdated();
    this.unsubscribeEcritureLineDeleted();
    this.unsubscribeLettageDone();
  }

  static getDerivedStateFromProps = async (props, state) => {
    //console.log("getDerivedStateFromProps", props);

    if (props && props.data && props.data.ecritureLinesConnectionForEarnings) {
      state.data = props.data;

      let edges =
        state &&
        state.data &&
        state.data.ecritureLinesConnectionForEarnings &&
        state.data.ecritureLinesConnectionForEarnings.edges;

      if (edges) {

        // bank transaction -> bank name
        // _.forEach(edges, o => {
        //   if (o.node && o.node.bankTransaction !== null) {
        //     // console.log("239 - !!!!!!!=", o.node);

        //     if (o.node.tiers === null) {
        //       const fakeTiers = {
        //         id: "fake_" + o.node.bankTransaction.bankAccount.id,
        //         name: o.node.bankTransaction.bankAccount.name,
        //         client: null,
        //         group: null
        //       }
        //       o.node.tiers = fakeTiers;
        //     }
        //   }
        // });

        /// TRANSLATIONS.....
        _.forEach(edges, o => {
          if (o.node && o.node.category && o.node.category.ids !== null) {
            // console.log("=>", o.node.category.ids);
            o.node.category.name = props.intl.formatMessage({
              id: o.node.category.ids
            });
          }

          if (
            o.node &&
            o.node.category &&
            o.node.category &&
            o.node.category.categoryFamily &&
            o.node.category.categoryFamily.ids !== null
          ) {
            o.node.category.categoryFamily.name = props.intl.formatMessage({
              id: o.node.category.categoryFamily.ids
            });
          }

          if (o.node && o.node.tiersClient && o.node.tiersClient.id === "FAKE_ID_CLIENT") {
            o.node.tiersClient.name = props.intl.formatMessage({
              id: o.node.tiersClient.name
            });
          }
          if (o.node && o.node.project && o.node.project.id === "FAKE_ID_PROJECT") {
            o.node.project.name = props.intl.formatMessage({
              id: o.node.project.name
            });
          }
        });

        edges = _.orderBy(
          edges,
          [
            "node.tiers.name",
            "node.tiers.tiersClient.name",
            "node.category.categoryFamily.name",
            "node.category.name",
            "node.project.name",
            "node.article.name"
          ],
          ["asc", "asc", "asc", "asc", "asc", "asc"]
        );
        state.data.ecritureLinesConnectionForEarnings.edges = edges;
      }
    }
  };

  render() {
    console.log("EarningsChart render");

    const edges =
      this.state.data &&
      this.state.data.ecritureLinesConnectionForEarnings &&
      this.state.data.ecritureLinesConnectionForEarnings.edges;

    return (
      <div>
        <ReportingChart
          {...this.props}
          edges={edges}
          negateValues={true}
          type="earnings"
          tabs={["categories", "tiers", "project", "client"]}
          onRowClick={(id, state, rowInfo, column, instance) => {
            console.log("EarningsChart rowInfo", rowInfo);
            if (rowInfo.original && rowInfo.original.invoice)
              this.props.history.push(
                `/invoices/${rowInfo.original.invoice.id}/view`
              );
            else if (rowInfo.original && rowInfo.original.bankTransaction)
              this.props.history.push(
                `/payments/${rowInfo.original.bankTransaction.id}/affectation`
              );

            // if (rowInfo.original && rowInfo.original.invoice)
            //   this.props.history.push(
            //     `/invoices/${rowInfo.original.invoice.id}/edit`
            //   );

            // this.props.history.push(
            //   `/expenses/${rowInfo.original.expense.id}/edit`
            // );
          }}
        />
      </div>
    );
  }
}

export default withRouter(injectIntl(EarningsChart));
